import { DrawerBody, DrawerHeader } from '@chakra-ui/react';

import CancelButton from 'components/tables/CancelButton';
import ChakraDrawer from '@/components/presentational/Drawer';
import { TpmView } from '../';

function AssociatedAccountDrawer({
    isOpen,
    onClose,
    associatedAccounts,
    isLoadingState,
    darkMode,
}) {
    return (
        <ChakraDrawer isOpen={isOpen} onClose={onClose}>
            <DrawerHeader
                className={`font-['Segoe UI'] mb-9 text-xl font-bold leading-tight tracking-tight ${darkMode ? 'text-white' : 'text-neutral-800'}`}>
                Mobile Numbers
            </DrawerHeader>
            <DrawerBody>
                <TpmView
                    associatedAccounts={associatedAccounts}
                    isLoadingState={isLoadingState}
                    onClose={onClose}
                />
                <div className="mt-[30px]">
                    <CancelButton onClick={onClose} />
                </div>
            </DrawerBody>
        </ChakraDrawer>
    );
}

export default AssociatedAccountDrawer;
